import StockOpnameResultDetail from '@/models/StockOpnameResult/StockOpnameResultDetail';

export default class StockOpnameResultDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.stockOpnameResultId  = '';
		this.stockOpnameResultStoResultNumber = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.qtySystem = '';
		this.totalPriceQtySystem = '';
		this.qtyActual = '';
		this.totalPriceQtyActual = '';
		this.totalDifferenceQty = '';
		this.totalDifferencePrice = '';
		this.differenctPercentage = '';
		this.scannedDateFrom = '';
		this.scannedDateTo = '';
		this.scannedById  = '';
		this.scannedByFirstName = '';
		this.stockOpnameDetailId  = '';
		this.stockOpnameDetailControlCard = '';
		this.remarks = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			stockOpnameResultId : '0',
			stockOpnameResultStoResultNumber : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			qtySystem : '0',
			totalPriceQtySystem : '0',
			qtyActual : '0',
			totalPriceQtyActual : '0',
			totalDifferenceQty : '0',
			totalDifferencePrice : '0',
			differenctPercentage : '0',
			scannedDateFrom : '0',
			scannedDateTo : '0',
			scannedById : '0',
			scannedByFirstName : '0',
			stockOpnameDetailId : '0',
			stockOpnameDetailControlCard : '0',
			remarks : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}